import { BiMap } from "react-icons/bi";
import { FiMail, FiPhone } from "react-icons/fi";

const ContactInfo = () => {
  return (
    <div className="grid grid-cols-1 gap-6 py-16 sm:grid-cols-2 md:grid-cols-3">
      {/* Phone Number Section */}
      <div className="text-center">
        <a href="tel:+918319579035" className="icon-box !h-14 !w-14 !bg-primary text-white mx-auto text-2xl flex justify-center items-center">
          <FiPhone />
        </a>
        <h1 className="mt-2 text-lg font-semibold">Phone Number</h1>
        <p>Mr. Ankit Gurjar</p>
        <a href="tel:+918319579035"  target="_blank" rel="noopener noreferrer"  className="text-blue-500 hover:underline">+91 8319579035</a>
      </div>

      {/* Email Address Section */}
      <div className="text-center">
        <a href="mailto:carepoohomecare@gmail.com"  target="_blank" rel="noopener noreferrer"  className="icon-box !h-14 !w-14 !bg-primary text-white mx-auto text-2xl flex justify-center items-center">
          <FiMail />
        </a>
        <h1 className="mt-2 text-lg font-semibold">Email Address</h1>
        <p>
          <a href="mailto:carepoohomecare@gmail.com"  target="_blank" rel="noopener noreferrer"  className="text-blue-500 hover:underline">
            carepoohomecare@gmail.com
          </a>
        </p>
        <p>
          <a href="mailto:ankitgurjar96175@gmail.com"  target="_blank" rel="noopener noreferrer"  className="text-blue-500 hover:underline">
            ankitgurjar96175@gmail.com
          </a>
        </p>
      </div>

      {/* Office Address Section */}
      <div className="text-center">
        <div className="icon-box !h-14 !w-14 !bg-primary text-white mx-auto text-2xl">
          <BiMap />
        </div>
        <h1 className="mt-2 text-lg font-semibold">Office Address</h1>
      <a href="https://maps.app.goo.gl/17385MNovL8mDMPt6"  target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline" >
        <p>1734, Gauri Nagar Main Rd, Veena Nagar, DDU Nagar,</p>
        <p>Sukhliya, Indore, Madhya Pradesh 452003</p>
        </a>
      </div>
    </div>
  );
};

export default ContactInfo;


